import {BaseSupplier} from '@dms/api/warehouse';

import {Nullish} from 'shared/web';

export const getSupplierById = (
  customersAsSuppliers: BaseSupplier[],
  supplierId: string | Nullish
) => customersAsSuppliers.find((customersAsSupplier) => customersAsSupplier.id === supplierId);
